export default "__VITE_ASSET__c4043acd__"